"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _userLock = _interopRequireDefault(require("cccisd-icons/user-lock"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning"));
var _FormPermission = _interopRequireDefault(require("./FormPermission"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ModalForm = function ModalForm(_ref) {
  var settings = _ref.settings,
    row = _ref.row,
    loadData = _ref.loadData,
    extraData = _ref.extraData;
  var isProjectAdmin = settings.type === 'questProjectAdmin';
  var noList;
  if (isProjectAdmin) {
    var questProjectList = row['targetedGroups.questprojectList'];
    var isGlobalAdmin = row['pawn.pawnId'] === row['globalAdminCheck.pawnId'];
    if (questProjectList.length === 0 && !isGlobalAdmin) {
      noList = true;
    }
  } else {
    var noTargets = row['targetedByPawns.questprojectadminList'].length === 0;
    var noGlobal = extraData['roles.questprojectadminList'].length === 0;
    if (noTargets && noGlobal) {
      noList = true;
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    size: "large",
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      id: "permission-button-".concat(row['pawn.pawnId'] || row['group.groupId']),
      type: "button",
      className: noList ? 'btn btn-warning' : 'btn btn-primary',
      style: {
        color: noList ? 'black' : '#fff'
      }
    }, noList ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_warning["default"], {
      spaceRight: true
    }), " Permissions") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_userLock["default"], {
      spaceRight: true
    }), " Permissions")),
    title: "".concat(isProjectAdmin ? 'Quest Admin' : 'Quest Project', " Permissions - ").concat(isProjectAdmin ? row['user.username'] : row["group.label"]),
    bodyStyle: {
      overflow: 'hidden'
    },
    render: function render(_ref2) {
      var closeModal = _ref2.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_FormPermission["default"], {
        settings: settings,
        row: row,
        onSubmit: function onSubmit() {
          closeModal();
          loadData();
        }
      });
    }
  });
};
var _default = exports["default"] = ModalForm;